module.exports = __webpack_public_path__ + "img/SELO-PERDIDO.a4fef91a.png";